var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMurFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 33.75h60V45H0V33.75Z",
    fill: "#00A04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.25h60V22.5H0V11.25Z",
    fill: "#151F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v11.25H0V0Z",
    fill: "#EE2737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5h60v11.25H0V22.5Z",
    fill: "#FFCD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMurFlag);
export default __webpack_public_path__ + "static/media/mur-flag.d55938960b0df0fb9118fc99254300ab.svg";
export { ForwardRef as ReactComponent };